import ChatPreview from './chat-preview';

export default ChatPreview;
